import { render, staticRenderFns } from "./Partial-usermenu.vue?vue&type=template&id=594c4720&scoped=true"
import script from "./Partial-usermenu.vue?vue&type=script&lang=js"
export * from "./Partial-usermenu.vue?vue&type=script&lang=js"
import style0 from "./Partial-usermenu.vue?vue&type=style&index=0&id=594c4720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594c4720",
  null
  
)

export default component.exports